export const deepQuerySelectorAll = (selectors, root) => {
    if (!root || !selectors) {
        return [];
    }
    const result = new Set();
    if (root instanceof Element && root.shadowRoot) {
        deepQuerySelectorAll(selectors, root.shadowRoot).forEach((el) => result.add(el));
    }
    root.querySelectorAll(selectors).forEach((el) => result.add(el));
    for (const child of root.children) {
        deepQuerySelectorAll(selectors, child).forEach((el) => result.add(el));
    }
    return Array.from(result);
};
export const deepQuerySelector = (selectors, root) => {
    if (!root || !selectors) {
        return null;
    }
    let result;
    if (root instanceof Element && root.shadowRoot) {
        result = deepQuerySelector(selectors, root.shadowRoot);
        if (result) {
            return result;
        }
    }
    result = root.querySelector(selectors);
    if (result) {
        return result;
    }
    for (const child of root.children) {
        result = deepQuerySelector(selectors, child);
        if (result) {
            return result;
        }
    }
    return null;
};
//# sourceMappingURL=deep-query.js.map